import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { UygulamaErisimService } from '@/src/app/shared/abonelik/uygulama-erisim.service';
import { UYGULAMA_BUL } from '@/src/app/shared/abonelik/uygulama-katalog';

/** Platform uygulaması erişim guard'ı. route.data.animasyonTag (= emoji) ile katalog/izin kontrolü. */
export const uygulamaErisimGuard = async (route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) => {
  const erisim = inject(UygulamaErisimService);
  const router = inject(Router);
  const bildirim = inject(NzNotificationService);

  const id: string = route.data?.['animasyonTag'] || route.data?.['simge'] || '';
  if (await erisim.erisebilir(id)) {
    // Kampanyayla ücretsiz açıldıysa kullanıcıya "normalde ücretli, şimdilik ücretsiz" bildir.
    const ad = UYGULAMA_BUL(id)?.baslik || route.data?.['baslik'] || '';
    erisim.kampanyaBildir(id, ad);
    return true;
  }

  const t = UYGULAMA_BUL(id);
  if (t?.mod === 'ucretli') {
    bildirim.warning('Ücretli Uygulama', `"${t.baslik}" ücretli bir modüldür (${t.aylikFiyat} ₺/ay). Paketleri inceleyip teklif alabilirsiniz.`, { nzDuration: 6000 });
    return router.createUrlTree(['/🧩/💎']);   // fiyatlandırma sayfasına (📢 yönlendirmesiyle döngü olmaz)
  }
  bildirim.error('Erişim Yok', `"${t?.baslik || 'Bu uygulama'}" için yetkiniz yok.`, { nzDuration: 5000 });
  return router.createUrlTree(['/🧩']);
};
